import { omit } from 'lodash';
import { TagType } from '../../../__generated__/queries-web';
import { DEFAULT_CATEGORY_FORM } from '../constants';
import type { Category, CategoryForm } from '../types';
import { ALLOWED_CATEGORY_FORM_SECTIONS } from '../views/Edit/constants';
import { getCategoryFormSection } from './categoryFormSection.model';

export const getCategoryForm = ({
  body,
  brandKey,
  createdAt,
  description,
  format,
  isHeadlined,
  id,
  level,
  medias,
  publishedAt,
  slug,
  status,
  subtitle,
  title,
  tabs,
  tags,
  editedAt,
  parent,
  updatedAt,
}: Partial<Category>): CategoryForm => {
  const parsedTags = tags ?? DEFAULT_CATEGORY_FORM.tags;
  let parsedMedias = DEFAULT_CATEGORY_FORM.medias;
  const parsedBodyDraft = body ?? DEFAULT_CATEGORY_FORM.description;

  if (medias) {
    try {
      parsedMedias =
        typeof medias === 'string'
          ? JSON.parse(medias).filter(Boolean)
          : medias.filter(Boolean);
    } catch (e) {}
  }

  return {
    ...(id && { id }),
    ...(createdAt && { createdAt }),
    ...(editedAt && { editedAt }),
    ...(updatedAt && { updatedAt }),
    brandKey: brandKey || DEFAULT_CATEGORY_FORM.brandKey,
    description: parsedBodyDraft,
    descriptionSEO: description || DEFAULT_CATEGORY_FORM.descriptionSEO,
    format: format || DEFAULT_CATEGORY_FORM.format,
    isHeadlined: isHeadlined || DEFAULT_CATEGORY_FORM.isHeadlined,
    level: level || DEFAULT_CATEGORY_FORM.level,
    medias: parsedMedias,
    parent: parent?.id
      ? {
          id: parent.id,
          title: parent.title,
          ...omit(parent, ['__typename', 'id', 'title']),
        }
      : DEFAULT_CATEGORY_FORM.parent,
    publishedAt: publishedAt || DEFAULT_CATEGORY_FORM.publishedAt,
    sections:
      tabs
        ?.filter(
          (tab) =>
            ALLOWED_CATEGORY_FORM_SECTIONS.findIndex(
              (allowedSection) => allowedSection.type === tab.type,
            ) > -1,
        )
        .map(getCategoryFormSection) || DEFAULT_CATEGORY_FORM.sections,
    slug: slug || DEFAULT_CATEGORY_FORM.slug,
    subTitle: subtitle || DEFAULT_CATEGORY_FORM.subTitle,
    status: status || DEFAULT_CATEGORY_FORM.status,
    tags: parsedTags.map((tagWrapper: any) => ({
      id: tagWrapper.tag.id,
      title: tagWrapper.tag.title,
      type: TagType.Tag,
      isActive: tagWrapper.tag.isActive || false,
    })),
    title: title || DEFAULT_CATEGORY_FORM.title,
  };
};
